<div *ngIf="enableTab" class="widget" [class.loading-widget]="loading" [class.widget--no-data]="noData">
    <span class="widget__title" *ngIf="!isInPopup">
        <span>{{'Total Cost of Repairs' | translate | async}}</span>
        <i class="material-icons" [matTooltip]="'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above. ' | translate | async">info</i>
        <i class="material-icons" [matTooltip]="'Enlarge ' | translate | async | translate | async" (click)="openWithANewPopup()">zoom_in</i>

    </span>
    <div [ngClass]="{'widget__content' : !isInPopup , 'large-widget' : isInPopup}">
        <div class="spinner-container" *ngIf="loading">
            <mat-spinner></mat-spinner>
        </div>
        <fusioncharts *ngIf="!loading" [hidden]="loading" [id]="chartid" [width]="width" [height]="height" [type]="type"
            [dataFormat]="dataFormat" [dataSource]="dataSource"></fusioncharts>
    </div>
    <div class="widget__no-data" *ngIf="noData">
        <span>{{'You haven\'t recorded any repair costs yet.' | translate | async}}</span>
    </div>
</div>